'use client'

import { MoonIcon, SunIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useColorMode } from './ui/color-mode'

export const ThemeSwitcher = () => {
  const [mounted, setMounted] = useState(false)
  const { colorMode, setColorMode } = useColorMode()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'toggleTheme',
  })

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <div className="flex w-full gap-2">
      <button
        aria-label={t('label')}
        className={`flex h-9 w-full min-w-8 items-center justify-center rounded border bg-background transition-colors hover:bg-muted ${
          colorMode === 'light' ? 'ring-2 ring-ring' : ''
        }`}
        onClick={() => setColorMode('light')}
        type="button"
      >
        <SunIcon className="size-5" />
      </button>
      <button
        aria-label={t('label')}
        className={`flex h-9 w-full min-w-8 items-center justify-center rounded border bg-background transition-colors hover:bg-muted ${
          colorMode === 'dark' ? 'ring-2 ring-ring' : ''
        }`}
        onClick={() => setColorMode('dark')}
        type="button"
      >
        <MoonIcon className="size-5" />
      </button>
    </div>
  )
}

ThemeSwitcher.displayName = 'ThemeSwitcher'
